import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiPath } from 'constants/api';
import loggerGenerator from '@travel/logger';
import type { AIFunctionFlag, AITitle } from './type';
import type { ApiClient } from '@travel/api-client';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const generateAItitle = createAsyncThunk<
  AITitle,
  string,
  { extra: { apiClient: ApiClient } }
>('ai/generateTitle', async (comment: string, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const title = await apiClient.post(apiPath.generateTitle.pathname, {
      values: { reviewContent: comment },
      ignoreCommonErrorHandler: true,
    });

    return title;
  } catch (error) {
    noticeError('AI Generate Title Failed', error);

    return rejectWithValue(error);
  }
});

export const fetchTitleGenerationConfig = createAsyncThunk<
  AIFunctionFlag,
  void,
  { extra: { apiClient: ApiClient } }
>('ai/fetchConfig', async (_arg, { extra: { apiClient }, rejectWithValue }) => {
  const url = apiPath.aiTitleConfig.pathname;

  if (!url) return;

  try {
    const response = await apiClient.get(url, {
      ignoreCommonErrorHandler: true,
      isThirdPartyApi: true,
      customParams: {
        isStaticFile: true,
      },
    });

    return response;
  } catch (error) {
    logger.error('AI Fetch Config Failed', error);
    noticeError('AI Fetch Config Failed', error);

    return rejectWithValue(error);
  }
});
